import { Injectable } from '@angular/core';
import { createEffect, Actions } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/angular';
import { of } from 'rxjs';
import { LabourOperationsState } from './labour-operations.interfaces';
import { LoadData, DataLoaded } from './labour-operations.actions';

@Injectable()
export class LabourOperationsEffects {
  
  loadData = createEffect(() => this.dataPersistence.fetch('LOAD_DATA', {
    run: (action: LoadData, state: LabourOperationsState) => {
      return {
        type: 'DATA_LOADED',
        payload: {}
      };
    },

    onError: (action: LoadData, error) => {
      console.error('Error', error);
    }
  }));

  constructor(private actions: Actions, private dataPersistence: DataPersistence<LabourOperationsState>) {}
}
